import {RECEIVE_FILTERED_RESULTS} from '../../actions/filteredResultActions';

import {getFilterStrategy} from '../../strategies/filterStrategies/filterStrategyFactory';

const FilteredResultsReducer = (state = [], action) => {
    switch (action.type) {
        case RECEIVE_FILTERED_RESULTS:
            if (!action.allResults) {
                return state;
            }

            if (!action.resultsConfig) {
                return action.allResults;
            }

            if (action.filters.length < 1) {
                // If no filters were selected & assessment type is guide-sections, return empty results
                if (action.resultsConfig.displayType === 'guide-sections') {
                    return [];
                }

                // //Otherwise, always show all results if no filters applied
                return action.allResults;
            }

            const filter = getFilterStrategy(action.resultsConfig);
            const filteredResults = filter(action.allResults, action.filters, action.prompts);

            const newState = filteredResults;
            return newState;

        default:
            return state;
    }
};

export default FilteredResultsReducer;
